import CalendarContainer from './CalendarContainer';

export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/components/organisms/Calendar/index.js